export const laendercodeToLaenderschluesselMap: Map<string, string> = new Map<string, string>([
  ['AF', '660'],
  ['EG', '220'],
  ['AL', '070'],
  ['DZ', '208'],
  ['VI', '457'],
  ['UM', '832'],
  ['AS', '830'],
  ['AD', '043'],
  ['AO', '330'],
  ['AI', '446'],
  ['AQ', '891'],
  ['AG', '459'],
  ['GQ', '310'],
  ['AR', '528'],
  ['AM', '077'],
  ['AW', '474'],
  ['AZ', '078'],
  ['ET', '334'],
  ['AU', '800'],
  ['BS', '453'],
  ['BH', '640'],
  ['BD', '666'],
  ['BB', '469'],
  ['BE', '017'],
  ['BZ', '421'],
  ['BJ', '284'],
  ['BM', '413'],
  ['BT', '675'],
  ['BO', '516'],
  ['BA', '093'],
  ['BW', '391'],
  ['BV', '892'],
  ['BR', '508'],
  ['VG', '468'],
  ['IO', '357'],
  ['BN', '703'],
  ['BG', '068'],
  ['BF', '236'],
  ['BI', '328'],
  ['CL', '512'],
  ['CN', '720'],
  ['CK', '837'],
  ['CR', '436'],
  ['CI', '272'],
  ['DK', '008'],
  ['DM', '460'],
  ['DO', '456'],
  ['DJ', '338'],
  ['EC', '500'],
  ['SV', '428'],
  ['ER', '336'],
  ['EE', '053'],
  ['FK', '529'],
  ['FO', '041'],
  ['FJ', '815'],
  ['FI', '032'],
  ['FR', '001'],
  ['TF', '894'],
  ['PF', '822'],
  ['GA', '314'],
  ['GM', '252'],
  ['GE', '076'],
  ['GH', '276'],
  ['GI', '044'],
  ['GD', '473'],
  ['GR', '009'],
  ['GL', '406'],
  ['GU', '831'],
  ['GT', '416'],
  ['GN', '260'],
  ['GW', '257'],
  ['GY', '488'],
  ['HT', '452'],
  ['HM', '835'],
  ['HN', '424'],
  ['HK', '740'],
  ['IN', '664'],
  ['ID', '700'],
  ['IQ', '612'],
  ['IR', '616'],
  ['IE', '007'],
  ['IS', '024'],
  ['IL', '624'],
  ['IT', '005'],
  ['JM', '464'],
  ['JP', '732'],
  ['YE', '653'],
  ['JO', '628'],
  ['KY', '463'],
  ['KH', '696'],
  ['CM', '302'],
  ['CA', '404'],
  ['CV', '247'],
  ['KZ', '079'],
  ['QA', '644'],
  ['KE', '346'],
  ['KG', '083'],
  ['KI', '812'],
  ['CC', '833'],
  ['CO', '480'],
  ['KM', '375'],
  ['CG', '318'],
  ['CD', '322'],
  ['KR', '728'],
  ['HR', '092'],
  ['CU', '448'],
  ['KW', '636'],
  ['LA', '684'],
  ['LS', '395'],
  ['LV', '054'],
  ['LB', '604'],
  ['LR', '268'],
  ['LY', '216'],
  ['LI', '037'],
  ['LT', '055'],
  ['LU', '018'],
  ['MO', '743'],
  ['MG', '370'],
  ['MK', '096'],
  ['MW', '386'],
  ['MY', '701'],
  ['MV', '667'],
  ['ML', '232'],
  ['MT', '046'],
  ['MA', '204'],
  ['MH', '824'],
  ['MR', '228'],
  ['MU', '373'],
  ['YT', '377'],
  ['MX', '412'],
  ['FM', '823'],
  ['MC', '147'],
  ['MN', '716'],
  ['MS', '470'],
  ['MZ', '366'],
  ['MM', '676'],
  ['NA', '389'],
  ['NR', '803'],
  ['NP', '672'],
  ['NC', '809'],
  ['NZ', '804'],
  ['NI', '432'],
  ['NL', '003'],
  ['AN', '478'],
  ['NE', '240'],
  ['NG', '288'],
  ['NU', '838'],
  ['MP', '820'],
  ['NF', '836'],
  ['NO', '028'],
  ['OM', '649'],
  ['AT', '038'],
  ['PK', '662'],
  ['PW', '825'],
  ['PA', '442'],
  ['PG', '801'],
  ['PY', '520'],
  ['PE', '504'],
  ['PH', '708'],
  ['PN', '813'],
  ['PL', '060'],
  ['PT', '010'],
  ['RW', '324'],
  ['RO', '066'],
  ['RU', '075'],
  ['SB', '806'],
  ['ZM', '378'],
  ['WS', '819'],
  ['SM', '047'],
  ['ST', '311'],
  ['SA', '632'],
  ['SE', '030'],
  ['CH', '039'],
  ['SN', '248'],
  ['CS', '094'],
  ['SC', '355'],
  ['SL', '264'],
  ['ZW', '382'],
  ['SG', '706'],
  ['SK', '063'],
  ['SI', '091'],
  ['SO', '342'],
  ['ES', '011'],
  ['LK', '669'],
  ['SH', '329'],
  ['KN', '449'],
  ['LC', '465'],
  ['PM', '408'],
  ['VC', '467'],
  ['ZA', '388'],
  ['SD', '224'],
  ['GS', '893'],
  ['SR', '492'],
  ['SZ', '393'],
  ['SY', '608'],
  ['TJ', '082'],
  ['TW', '736'],
  ['TZ', '352'],
  ['TH', '680'],
  ['TL', '626'],
  ['TG', '280'],
  ['TK', '839'],
  ['TO', '817'],
  ['TT', '472'],
  ['TD', '244'],
  ['CZ', '061'],
  ['TN', '212'],
  ['TR', '052'],
  ['TM', '080'],
  ['TC', '454'],
  ['TV', '807'],
  ['UG', '350'],
  ['UA', '072'],
  ['HU', '064'],
  ['UY', '524'],
  ['UZ', '081'],
  ['VU', '816'],
  ['VA', '045'],
  ['VE', '484'],
  ['AE', '647'],
  ['US', '400'],
  ['VN', '690'],
  ['WF', '811'],
  ['CX', '834'],
  ['BY', '073'],
  ['CF', '306'],
  ['GB', '006'],
  ['CY', '600']
]);
